import {Record as record} from 'immutable';

import {construct, fields} from '../../helpers/LinkMapper';
import {getResolvers, getDefaults} from '../../helpers/Records';

const schema = {
    id: [fields.number],
    cardPan: [fields.string],
    cardType: [fields.string],
    cardHolderName: [fields.string],
    amount: [fields.number],
    originalAmount: [fields.number],
    amountRefunded: [fields.number],
    transactionId: [fields.string],
    created: [fields.datetime],
    refunded: [fields.boolean],
    latest: [fields.boolean],
};

export default class CardPayment extends record(getDefaults(schema)) {
    static fromJSON(json = {}) {
        return construct(CardPayment, json, getResolvers(schema));
    }

    get pan() {
        return this.cardPan;
    }

    get transactionReference() {
        return this.transactionId;
    }

    hasAmount() {
        return this.amount > 0;
    }

    isRefundable() {
        return this.hasAmount();
    }

    hasLatestPayment() {
        return this.latest;
    }

    getPaymentAmount() {
        return this.amount;
    }
}
